import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { findUseCasePage } from '../marketing/use-case-pages';
import { useLocale } from '../contexts/LocaleContext';

const BASE_URL = 'https://scribane.com';

const DEFAULT_TITLE = 'Scribane — Writing environment for storytellers';
const DEFAULT_DESCRIPTION =
  'The writing environment for storytellers. Plan, write, revise, and collaborate on novels, articles, and scripts — from any device, online or offline.';

function setMetaBySelector(selector: string, attribute: string, value: string): void {
  const element = document.querySelector(selector);
  if (element) {
    element.setAttribute(attribute, value);
  }
}

export const DocumentMeta: React.FC = () => {
  const { pathname } = useLocation();
  const { t } = useLocale();

  useEffect(() => {
    const useCase = findUseCasePage(pathname);
    const title = useCase ? t(`${useCase.keyPrefix}_meta_title`) : DEFAULT_TITLE;
    const description = useCase ? t(`${useCase.keyPrefix}_meta_description`) : DEFAULT_DESCRIPTION;
    const canonicalPath = pathname === '/' ? '' : pathname;
    const url = `${BASE_URL}${canonicalPath}`;

    document.title = title;

    setMetaBySelector('meta[name="description"]', 'content', description);
    setMetaBySelector('link[rel="canonical"]', 'href', url);
    setMetaBySelector('meta[property="og:title"]', 'content', title);
    setMetaBySelector('meta[property="og:description"]', 'content', description);
    setMetaBySelector('meta[property="og:url"]', 'content', url);
  }, [pathname, t]);

  return null;
};
